// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"23":"agenda","914":"publishers","963":"event"}[chunkId] + "." + {"23":"b989fc3f","914":"c3fc5833","963":"9cc6dde3"}[chunkId] + ".css";
};